export const state = () => ({
  selectedDataSetDetails: null,
  dataset: [],
  // Flag representing if component is used as a dashboard widget
  isWidget: false,
  datasetListLoadingFlag: false
});
